import { CartImpressionTrackingInfo } from "@services/tracking/types/trackingInfo/cartImpressionTrackingInfo";
import { CartProductTrackingInfo } from "@services/tracking/types/trackingInfo/cartProductTrackingInfo";

import { OrderDetailsModel } from "@redux/modules/api/data/orderDetail/@types/orderDetails.model";
import { OrderItemModel } from "@redux/modules/api/data/orderDetail/@types/orderItem.model";

const warrantyProductInfo = {
    name: "Waarborg pallet",
    analytics: {
        productTitle: "Waarborg pallet",
        superCategoryCode: "waarborg",
        superCategoryName: "Waarborg",
    },
};

const getOrderDetailsImpressionTrackingInfo = (
    orderDetails: OrderDetailsModel,
    name: string,
): CartImpressionTrackingInfo => {
    const setWarranty = (item: OrderItemModel) => {
        if (item.warrantyDeposit) {
            item.title = item.title || warrantyProductInfo.name;
            item.analytics = item.analytics || warrantyProductInfo.analytics;
        }
        return item;
    };
    const cartItems = (orderDetails.items || [])
        .map(setWarranty)
        .filter(item => item.hasProduct);

    return {
        name,
        email: orderDetails.customer.email,
        totalPrice: orderDetails.totalPrice,
        promotions: orderDetails.promotions,
        globalDiscounts: orderDetails.globalDiscounts,
        deliveryCost: orderDetails.deliveryCost,
        orderId: orderDetails.orderId,
        items: cartItems.map(
            (item: OrderItemModel, index: number): CartProductTrackingInfo => {
                const { productTitle = "", superCategoryCode = "" } =
                    item.analytics || {};
                const reduction = item.strikethroughPrice
                    ? item.strikethroughPrice - item.totalPrice
                    : 0;

                return {
                    name: productTitle || item.title || "",
                    id: item.sku,
                    ean: item.ean,
                    category: superCategoryCode,
                    price: item.totalPrice,
                    unitPrice: item.unitPrice,
                    tax: "21%",
                    reduction: reduction,
                    currencyCode: "EUR",
                    quantity: item.quantity,
                    url: item.url,
                    placement: index + 1,
                    brand: item.brandName || "",
                };
            },
        ),
    };
};

export { getOrderDetailsImpressionTrackingInfo };
